import { scrollTo } from '../_utils/scrollTo.js';
const HISTORY_SUPPORT = !!(window.history && window.history.pushState);
export const offsetAnchors = () => {
  // Path prefix is the difference between the url and the website's root.
  const PATH_PREFIX = window.location.pathname + '#';
  const scrollToAnchor = (href, pushToHistory) => {
    if (href.substring(0, PATH_PREFIX.length) === PATH_PREFIX) {
      pushToHistory = false;
    }

    // Get element using hash as id.
    const hash = href.substring(href.indexOf('#') + 1);
    const target = window.document.getElementById(hash);
    if (!scrollTo(target, pushToHistory)) {
      return false;
    }

    // Add the state to history as-per normal anchor links.
    if (HISTORY_SUPPORT && pushToHistory) {
      const url = new URL(window.location);
      url.hash = hash;
      window.history.pushState({}, '', url);
    }
    return true;
  };
  const closeMenu = target => {
    // If in a menu that can open, close it.
    const navigationHeader = target.closest('header.nav-header');
    if (!navigationHeader) {
      return;
    }

    // Get all open toggles.
    const toggles = navigationHeader.querySelectorAll('button[aria-expanded="true"][data-toggle="collapse"][data-target],button[aria-expanded="true"][data-toggle="toggle"][data-target],button[aria-expanded="true"][data-purpose="collapse"][data-target],button[aria-expanded="true"][data-purpose="toggle"][data-target]');
    for (let i = 0; i < toggles.length; i++) {
      const toggle = toggles[i];

      // Check if pressed button is in the menu that the button targets.
      const menu = navigationHeader.querySelector(toggle.getAttribute('data-target'));
      if (menu && !menu.contains(target)) {
        continue;
      }

      // Invoke toggle click event to close the expanded menu.
      toggle.click();

      // Don't invoke multiple buttons, one should do the trick.
      break;
    }
  };
  window.document.body.addEventListener('click', event => {
    // Check if click.
    let target = event.target;
    if (target.nodeName !== 'A' || !target.hasAttribute('href')) {
      target = target.closest('a[href]');
      if (!target) {
        return false;
      }
    }
    const success = scrollToAnchor(target.getAttribute('href'), true);
    if (!success) {
      return;
    }
    // Prevent the event from propagating if the scrolling was successful.
    event.preventDefault();
    closeMenu(target);
  });
  window.addEventListener('hashchange', () => {
    scrollToAnchor(window.location.pathname + window.location.hash, false);
  });
  scrollToAnchor(window.location.pathname + window.location.hash, false);
};